import { ViewModelBase } from './ViewModelBase';
import { GameManager } from '../managers/GameManager';
import { GenerateUniqueRandomIntegerArray } from '../tools/math/UniqueRandomIntegerArray';
import { FindTheDifferencePuzzleModel } from '../models/FindTheDifferencePuzzleModel';
import { GameType } from '../models/CBNGameModel';

export class EagleEyeExamGameSceneModel extends ViewModelBase{

    private quiz:FindTheDifferencePuzzleModel;
    private gameManager:GameManager = (<GameManager>GameManager.instance);

    constructor(quiz:FindTheDifferencePuzzleModel){
        super();
        this.quiz = quiz;
    }

    update(timestep,dt){
        this.updateTimer(timestep,dt);
    }

    //General Getters
    getCurrentScore():number{
        return this.quiz.currentScore;
    }
    getCurrentRoundNumber():number{
        return this.quiz.currentRound;
    }
    getMaxLife():number{
        return this.quiz.maxLife;
    }
    getCurrentLife():number{
        return this.quiz.currentLife;
    }
    getCurrentQuestion():number{
        return this.quiz.currentQuestion;
    }
    getGameTimeRemaining():number{
        return this.quiz.currentGameTime;
    }
    getTimerProgress():number{
        let progress = this.quiz.currentTimeRemaining / this.quiz.timeLimitPerQuestion;
        return progress;
    }
    getTimeRemaining():number{
        return this.quiz.currentTimeRemaining + .5;
    }
    getTimeLimit():number{
        return this.quiz.timeLimitPerQuestion;
    }
    getGameTime():number{
        return this.quiz.getGameTime();
    }
    getIsPractice():boolean{
        return this.quiz.practiceMode;
    }
    private updateTimer(timestep,dt){
        
        if(this.quiz.practiceMode || this.isQuizDone()){
            return;
        }
        this.quiz.currentTimeRemaining -= dt / 1000;
        this.quiz.currentGameTime -= dt / 1000;

        if(this.quiz.currentTimeRemaining<=0){
            this.quiz.currentLife--;
            this.quiz.currentGivenAnswer = null;
            this.emitter.emit('OnTimerEnd');
            
        }
        if(this.quiz.currentGameTime<=0)
        {
            this.quiz.currentLife--;
            this.quiz.currentGivenAnswer = null;
            this.emitter.emit('OnTimerEnd');
        }
        this.emitter.emit('OnTimerChanged');
    }

    // private updatePracticeLife()
    // {
    //     if(!this.quiz.practiceMode){
    //         return;
    //     }

    //     this.quiz.currentLife--;
    //     this.emitter.emit('OnGiveAnswer');
    //     // this.emitter.emit('OnAttemptAnswer');

    //     let cache = this.gameManager.buildConfig;

    //     if(this.isQuizDone()){
    //         this.emitter.emit('OnQuizEnd');
    //         this.gameManager.cbnGameConfig!.onGameEnd(this.quiz.currentScore,cache.name);
    //     }

    // }

    //Quiz Specific Getters
    getFirstImageSources():string[]{
        return this.quiz.questions.map(question => question.firstImageSource);
    }
    getSecondImageSources():string[]{
        return this.quiz.questions.map(question => question.secondImageSource);
    }
    getAnswerZoneRectangleUpperLeft():Phaser.Math.Vector2{
        return this.quiz.questions[this.quiz.currentQuestion].answerUpperLeftPosition;
    }
    getAnswerZoneRectangleLowerRight():Phaser.Math.Vector2{
        return this.quiz.questions[this.quiz.currentQuestion].answerLowerRightPosition;
    }

    setFirstImageKey(key):void{
        this.quiz.questions[this.quiz.currentQuestion].firstImageKey = key;
    }

    getFirstImageKey():string{
        return this.quiz.questions[this.quiz.currentQuestion].firstImageKey;
    }

    setSecondImageKey(key):void{
        this.quiz.questions[this.quiz.currentQuestion].secondImageKey = key;
    }

    getSecondImageKey():string{
        return this.quiz.questions[this.quiz.currentQuestion].secondImageKey;
    }

    resetImageKeys():void{
        for(let i = 0; i < this.quiz.questions.length; i++)
        {
            this.quiz.questions[i].firstImageKey = "";
            this.quiz.questions[i].secondImageKey = "";
        }
    }

    clearAnswer():void{
        this.quiz.currentGivenAnswer = null;
    }

    //Conditionals
    isCurrentChoiceCorrect():boolean{
        //TODO:
        let question = this.quiz.questions[this.quiz.currentQuestion];
        let currentAnswer = this.quiz.currentGivenAnswer;
        if(currentAnswer && currentAnswer!.x >= question.answerUpperLeftPosition.x &&
            currentAnswer!.x <= question.answerLowerRightPosition.x &&
            currentAnswer!.y >= question.answerUpperLeftPosition.y &&
            currentAnswer!.y <= question.answerLowerRightPosition.y){
                
                return true;
        }
        return false;
    }
    isQuizDone():boolean{
        let result;
        if(this.quiz.currentQuestion >= this.quiz.questions.length || this.quiz.currentLife<=0 || this.quiz.currentGameTime! <= 0){
            result = true;
        }else{
            result = false;
        }
        //console.log(`IsQuizDone: ${result}`);
        return result;
    }

    //Commands
    giveAnswer(pointerPosition:Phaser.Math.Vector2){
        this.quiz.currentGivenAnswer = pointerPosition;

        //let correctAnswers = this.getCurrentQuestionCorrectAnswers();
        let result:boolean = this.isCurrentChoiceCorrect();

        if(result){
            this.quiz.currentCorrectAnswers++;
            let scoreIncrement = this.quiz.fullScorePerQuestion * this.getTimerProgress();
            this.quiz.currentScore += scoreIncrement;
            this.quiz.currentScore = Math.floor(this.quiz.currentScore);
            this.emitter.emit('OnGiveAnswer');
        }else{
            //Reduce Time on wrong Letter Choice
            this.quiz.currentTimeRemaining -= 3;
            this.quiz.currentTimeRemaining = Math.max(this.quiz.currentTimeRemaining,0);
            this.quiz.currentGameTime -= 3;
            this.quiz.currentGameTime = Math.max(this.quiz.currentGameTime,0.01);
        }

        this.emitter.emit('OnAttemptAnswer');
    }
    
    nextQuestion(){
        this.quiz.currentRound++;

        if(this.quiz.currentQuestion+1 >= this.quiz.questions.length){
            // this.quiz.isDone = true;
            this.quiz.currentQuestion = 0;
            
            //Shuffle currentChoices
            Phaser.Utils.Array.Shuffle(this.quiz.questions);
        }else{
            this.quiz.currentQuestion++;
        }
        
        let cache = this.gameManager.buildConfig;
        // console.log("CURRENT QUESTION ", this.quiz.currentQuestion);
        this.gameManager.cbnGameConfig!.onGameLevelComplete(this.quiz.currentScore,cache.name, this.gameManager.pracPlayOption);
        if(this.isQuizDone() || this.gameManager.cbnGameConfig!.gameType != GameType.full){
            this.emitter.emit('OnQuizEnd');
            this.gameManager.cbnGameConfig!.onGameEnd(this.quiz.currentScore, cache.name,this.gameManager.pracPlayOption);
        }else{
            this.quiz.currentTimeRemaining = this.quiz.timeLimitPerQuestion;
            //Reset letters
            
        }        
    }
}